import React, { useState } from 'react';
import Skeleton from 'react-loading-skeleton'
import { getGravatarImage, formatPoints } from "../../utils"
import './Avatar.css'
import 'react-loading-skeleton/dist/skeleton.css'

export function Avatar({ player, onClickPlayer, size = "250px", isSelected = false, isLocked = false }) {
    const [imageLoaded, setImageLoaded] = useState(false);
    const image = player.imageUrl && player.imageUrl.length > 0 && player.age >= 12
        ? player.imageUrl
        : getGravatarImage(player.name);

    const getHeight = () => {
        const numberPixels = parseInt(size.replace("px", ""));
        return numberPixels * 1.33;
    };

    const stats = player.stats?.[0] ?? null;
    const isGoalkeeper = stats?.position === "P";
    const fantasyPts = stats && !isGoalkeeper
        ? stats.goals + stats.assistances - stats.fouls / 60
        : null;

    return (
        <div className={`avatar-item${isSelected ? " avatar-item--selected" : ""}${isLocked ? " avatar-item--locked" : ""}`}
             onClick={() => onClickPlayer && onClickPlayer(player)}>
            {!imageLoaded && <Skeleton width={size} height={getHeight()} />}
            <img
                width={size}
                height={getHeight()}
                onLoad={() => setImageLoaded(true)}
                src={image}
                className={imageLoaded ? "avatar-image" : "avatar-image-hidden"}
                alt={player.name}
            />
            <span className="player-name">{player.name}</span>
            {stats && (
                <div className="player-card-stats">
                    <span className={`position-badge position-badge--${isGoalkeeper ? "gk" : "field"}`}>
                        {isGoalkeeper ? "POR" : "JUG"}
                    </span>
                    {!isGoalkeeper && (
                        <span className="player-stats-row">G:{stats.goals} A:{stats.assistances}</span>
                    )}
                    {isGoalkeeper && stats.catchesAvg > 0 && (
                        <span className="player-stats-row">{stats.catchesAvg.toFixed(1)}% prd</span>
                    )}
                    {fantasyPts !== null && (
                        <span className={`fantasy-pts${fantasyPts < 0 ? " fantasy-pts--negative" : ""}`}>
                            {fantasyPts >= 0 ? `+${formatPoints(fantasyPts)}` : formatPoints(fantasyPts)} pts
                        </span>
                    )}
                </div>
            )}
        </div>
    );
}
